import { useEffect, useState } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "react-bootstrap";
import Select from "react-select";
import { dataTel3GetUkList } from "../../../config/apiSPA.js";

export default function ModalTel3SelectUk({ show, onHide, submitClick = () => {}, trId = null, options = {}, selector = "", selected = null }) {
  const title = options.title ?? "No Title";
  const text = options.text ?? "please text here";

  const [selectedValue, setSelectedValue] = useState(null);
  const [option, setOption] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!show) return;

    const fetchOption = async () => {
      try {
        const res = await dataTel3GetUkList(trId);
        setOption(res);
        setLoading(false);
      } catch {
        setOption([]);
      }
    };

    fetchOption();
  }, [show, selector]);

  useEffect(() => {
    if (!show) setSelectedValue(null);
    if (!show) setLoading(true);
  }, [show]);

  useEffect(() => {
    if (!selected || option.length === 0) {
      setSelectedValue(null);
      return;
    }

    const selectedOption = option.find((opt) => opt.value === selected) || null;
    setSelectedValue(selectedOption);
  }, [selected, option]);

  const handleChange = (e) => {
    setSelectedValue(e ?? null);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <ModalHeader closeButton>
        <h5 className="modal-title">{title}</h5>
      </ModalHeader>
      <ModalBody>
        {loading ? (
          <p>Loading.....</p>
        ) : (
          <>
            <div className="mb-3">
              <Select value={selectedValue} onChange={handleChange} options={option} isSearchable classNamePrefix="react-select" />
            </div>

            <div className="alert bg-inverse bg-opacity-15">{text}</div>
          </>
        )}
      </ModalBody>

      <ModalFooter>
        <button type="button" disabled={!selectedValue} onClick={() => submitClick({ val: selectedValue.value })} className="btn btn-outline-theme">
          Save changes
        </button>
      </ModalFooter>
    </Modal>
  );
}
